import React from 'react';
import { useTranslation } from 'react-i18next';
import { useOpenLiveChat } from '@hub/hooks';
import { useMediaQuery } from '@mui/material';
import { Button, Stack, useTheme } from '@monorepo/nova-ui';

interface FormActionsProps {
  isLoading: boolean;
  isDisabled: boolean;
  onSubmit: () => void;
}

export const FormActions: React.FC<FormActionsProps> = ({
  isLoading,
  isDisabled,
  onSubmit,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { t } = useTranslation(['withdrawFundsNova', 'common']);
  const openLiveChat = useOpenLiveChat({ flow: 'payout-form' });

  const handleContactSupport = () => {
    openLiveChat();
  };

  return (
    <Stack
      direction={isMobile ? 'column-reverse' : 'row'}
      gap={isMobile ? theme.spacing(3) : theme.spacing(6)}
    >
      <Button
        variant="outlined"
        disabled={isLoading}
        onClick={handleContactSupport}
        sx={{ width: '100%' }}
        size={'xl'}
      >
        {t('withdrawFundsNova:contact_support')}
      </Button>
      <Button
        variant="primary"
        loading={isLoading}
        disabled={isDisabled}
        onClick={onSubmit}
        sx={{ width: '100%' }}
        size={'xl'}
      >
        {t('withdrawFundsNova:submit_cta')}
      </Button>
    </Stack>
  );
};
